"use client";
import { jsx as c } from "react/jsx-runtime";
import { memo as o } from "react";
import a from "../components/Icon/SvgIcon.js";
const v = (l) => /* @__PURE__ */ c(
  a,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ c(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.535 5.377a.28.28 0 0 0-.186.07c-.093.083-.093.121-.093.165v6.916c-.016.292-.08 2.612 2.158 4.995 1.204 1.273 2.874 2.353 4.96 3.208.125.017.156.012.19-.003 2.384-.972 4.219-2.251 5.45-3.803 1.705-2.155 1.636-4.14 1.623-4.359l-.001-.038V5.612c0-.02 0-.081-.1-.169-.041-.036-.087-.06-.176-.06-.347.04-.744.065-1.12.065-3.445 0-5.622-2.136-5.644-2.158-.07-.07-.232-.071-.3 0l-.028-.027c-.682.823-2.948 2.185-5.618 2.185-.376 0-.772-.025-1.115-.071M12.468 22q-.287 0-.564-.11c-2.257-.924-4.073-2.105-5.401-3.509-2.542-2.707-2.527-5.38-2.497-5.888l-.001-6.881c0-.426.174-.797.516-1.103a1.5 1.5 0 0 1 1.01-.377l.17.006c.285.038.632.059.949.059 2.676 0 4.453-1.509 4.708-1.74l.052-.053c.54-.538 1.528-.539 2.069-.001.033.03 1.922 1.794 4.762 1.794.317 0 .663-.021.948-.059l.17-.006q.58.001 1.006.374c.338.3.522.692.522 1.106v6.899c.026.484.03 2.758-1.892 5.191-1.368 1.723-3.374 3.13-5.961 4.187a1.5 1.5 0 0 1-.566.111m.934-9.451a.99.99 0 0 0-.987-.987.99.99 0 0 0-.99.987c0 .356.2.692.515.87l-.355 1.383a.26.26 0 0 0 .059.237c.06.059.138.118.217.118h1.127c.079 0 .178-.04.217-.118.059-.06.079-.158.059-.237l-.355-1.383c.296-.178.493-.494.493-.87m1.046 3.428c.759 0 1.377-.617 1.377-1.376v-2.503c0-.76-.618-1.376-1.377-1.376h-4.004c-.76 0-1.377.617-1.377 1.376V14.6c0 .759.618 1.376 1.377 1.376zm-1.752-8.51h-.5a1.38 1.38 0 0 0-1.377 1.378v.625h3.254v-.625c0-.76-.618-1.377-1.377-1.377m2.628 1.378v.787a2.62 2.62 0 0 1 1.752 2.466V14.6a2.63 2.63 0 0 1-2.628 2.627h-4.004A2.63 2.63 0 0 1 7.816 14.6v-2.503c0-1.14.735-2.103 1.752-2.466v-.787a2.63 2.63 0 0 1 2.628-2.628h.5a2.63 2.63 0 0 1 2.628 2.628",
        clipRule: "evenodd"
      }
    )
  }
), r = o(v);
export {
  r as PrivacyPolicy,
  r as default
};
